import React from "react"
import { IntlProvider } from "gatsby-plugin-react-intl"
import { graphql, useStaticQuery } from "gatsby"
import HTMLReactParser from "html-react-parser"
import { useState, useEffect, forwardRef } from "react"
import { Container, Row, Col } from "react-bootstrap"
import "./blockBooking.scss"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { useIntl } from "gatsby-plugin-react-intl"
import fr from "date-fns/locale/fr"
import * as moment from "moment"
import { addDays } from "date-fns"
import { Link } from "gatsby"
import { debounce } from "../../functions"
import { FormControl, Input, InputLabel, Select, MenuItem } from "@mui/material"
import { globalHistory } from "@reach/router"
import Vector1 from "./images/Vector1.svg"
import Vector2 from "./images/Vector2.svg"
import Vector3 from "./images/Vector3.svg"
import Vector4 from "./images/Vector4.svg"
import Vector5 from "./images/Vector5.svg"
import { hotelOptions } from "../../../services/form.service"

const BlockBooking = ({ hotel, extraClass, locale, roomId }) => {
  const intl = useIntl()
  const currentLanguage = locale === "fr" ? "fr" : "en"
  const breakpoint = 1025

  const [screen, setMobile] = useState({
    isMobile: typeof window !== `undefined` && window.innerWidth < breakpoint,
  })

  const [isClient, setClient] = useState(false)

  useEffect(() => {
    setClient(true)

    const debouncedHandleResize = debounce(function handleResize() {
      setMobile({
        isMobile:
          typeof window !== `undefined` && window.innerWidth < breakpoint,
      })
    }, 200)

    if (typeof window !== `undefined`) {
      window.addEventListener("resize", debouncedHandleResize)
    }
  }, [])

  //Remove class 'show' when url changes
  useEffect(() => {
    return globalHistory.listen(({ action }) => {
      if (action === "PUSH") {
        const contBookingBlock = document.querySelector(".bookingBar")
        contBookingBlock.classList.remove("show")
      }
    })
  }, [])

  //Handle Booking Layout
  const handleToggle = () => {
    const contBooking = document.querySelector(".bookingBar")
    const blkHtml = document.querySelector("html")
    const blkBookingMobile = document.querySelector(".bookingBar form")
    contBooking.classList.toggle("active")
    contBooking.classList.toggle("show")
    blkHtml.classList.toggle("activeBooking")
    blkBookingMobile.classList.toggle("hideForm")
  }

  const [dateRange, setDateRange] = useState([
    addDays(new Date(), 0),
    addDays(new Date(), 2),
    ,
  ])
  const [startDate, endDate] = dateRange
  const [lang, setLang] = useState(0)
  const [localeVal, setlocaleVal] = useState(0)

  let baseUrl,
    comfortRoom,
    comfortSeaViewRoom,
    superiorRoom,
    comfortFamilyRoom,
    privilegeRoom,
    privilegeSuite,
    familyUnit,
    teensUnit,
    classHotel,
    theme,
    dest,
    clearcache,
    idHotel,
    config

  function getCookie(key) {
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)")
    return b ? b.pop() : ""
  }
  //book now language ID for german
  useEffect(() => {
    const hashtag = window.location.hash
    const googleTransVal = getCookie("googtrans")

    if (hashtag === "#googtrans(de)" || googleTransVal.length > 0) {
      setLang(7)
      setlocaleVal("de-DE")
    } else {
      switch (currentLanguage) {
        case "fr":
          setLang(3)
          setlocaleVal("fr-FR")
          break
        default:
          setLang(1)
          setlocaleVal("en-US")
      }
    }
  }, [locale])

  // Handle media type change
  const [selectedHotel, setSelectedHotel] = useState(hotel)
  const handleHotelChange = e => {
    setSelectedHotel(e.target.value)
  }

  const [adults, setAdults] = React.useState("")
  const handleAdults = event => {
    setAdults(event.target.value)
  }

  const [child, setchild] = React.useState("")
  const handleChild = event => {
    setchild(event.target.value)
  }

  switch (selectedHotel) {
    case "verandaResorts":
      comfortRoom = "202795"
      comfortSeaViewRoom = "417452"
      baseUrl = "https://reservations.veranda-resorts.com/"
      theme = "VLH"
      config = "VLH"
      dest = "VLHR"
      break
    case "74764":
      comfortRoom = "202794"
      superiorRoom = "401260"
      familyUnit = "203112"
      privilegeRoom = "203113"
      baseUrl = "https://reservations.veranda-resorts.com/"
      theme = "DEFAULT"
      clearcache = "all"
      idHotel = "59975"
      break
    case "74760":
      comfortRoom = "202796"
      superiorRoom = "204612"
      comfortFamilyRoom = "274014"
      privilegeRoom = "204613"
      privilegeSuite = "204614  "
      baseUrl = "https://reservations.veranda-resorts.com/"
      theme = "DEFAULT"
      clearcache = "all"
      idHotel = "59977"
      break
    case "74762":
      comfortRoom = "202795"
      comfortSeaViewRoom = "417452"
      baseUrl = "https://reservations.veranda-resorts.com/"
      theme = "DEFAULT"
      clearcache = "all"
      idHotel = "59998"
      break
    case "106630":
      comfortRoom = "443025"
      teensUnit = "526146"
      privilegeRoom = "443026"
      baseUrl = "https://reservations.veranda-resorts.com/"
      theme = "DEFAULT"
      clearcache = "all"
      idHotel = "62925"
      break
    case "74756":
      comfortRoom = "303093"
      superiorRoom = "203093"
      privilegeRoom = "203094"
      baseUrl = "https://reservations.veranda-resorts.com/"
      theme = "DEFAULT"
      clearcache = "all"
      idHotel = "59996"
      break
    default:
      break
  }

  //Calculate Totals
  // const [input_values, set_inputvalues] = useState({
  //   child: 0,
  // })

  //const [total, set_total] = useState(0)

  useEffect(() => {
    // const arrValues = Object.values(input_values)
    // const inputTotals = arrValues.reduce((accum, curr) => (accum += curr), 0)
    // set_total(inputTotals)

    //Select Children
    // const selectChildren = document.querySelector("#children + input")
    // if (input_values.child === 0) {
    //   selectChildren.removeAttribute("name")
    // } else {
    //   selectChildren.setAttribute("name", "child")
    // }
    //Remove hotel
    const selectHotel = document.querySelector("#hotel + input")
    selectHotel.removeAttribute("name")
  })

  // const changeValues = ({ name, value }) => {
  //   set_inputvalues({ ...input_values, [name]: parseInt(value) })
  //   console.log(name, value)
  // }

  //Check
  // const handleCheckChange = event => {
  //   const inputCode = document.querySelector("#promo-code")
  //   const inputAgencyID = document.querySelector("#agencyid")
  //   const secondRow = document.querySelector(".secondRow")

  //   if (event.target.checked) {
  //     inputCode.setAttribute("name", "promo")
  //     inputAgencyID.setAttribute("name", "agencyid")
  //     secondRow.classList.add("show")
  //   } else {
  //     inputCode.removeAttribute("name")
  //     inputAgencyID.removeAttribute("name")
  //     secondRow.classList.remove("show")
  //   }
  // }

  //Add Class to menu guest
  // const guestBlk = () => {
  //   const blkGuestDet = document.querySelector(".blkGuestNum")
  //   blkGuestDet.classList.add("show")
  // }
  // const closeBlkGuest = () => {
  //   const blkGuestDet = document.querySelector(".blkGuestNum")
  //   blkGuestDet.classList.remove("show")
  // }

  //Prevent Typing date
  const handleDateChangeRaw = e => {
    e.preventDefault()
  }

  //Custom input for date picker
  const CustomDatePicker = forwardRef(
    ({ dept, customDay, customYear, onClick }, ref) => (
      <div className="bookCalendar" onClick={onClick} ref={ref}>
        <p className="bookCalendar-header"> {dept}</p>
        <p className="bookCalendar-day">{customDay}</p>
        <p className="bookCalendar-year">{customYear}</p>
      </div>
    )
  )

  const toggleAccordion = e => {
    e.currentTarget.classList.toggle("active")
    const blkWhyBook = document.querySelector(".blkWhyBook")
    blkWhyBook.classList.toggle("activeBlk")
    var panel = e.currentTarget.nextElementSibling
    if (panel.style.display === "block") {
      panel.style.display = "none"
    } else {
      panel.style.display = "block"
    }
  }

  const data = useStaticQuery(graphql`
    query blocBookList {
      blocBookListEn: blockContentBlockBookNow(langcode: { eq: "en" }) {
        block_book_now_text {
          value
        }
        block_book_now_telephone {
          value
        }
        block_book_now_title
      }
      blocBookListFr: blockContentBlockBookNow(langcode: { eq: "fr" }) {
        block_book_now_text {
          value
        }
        block_book_now_telephone {
          value
        }
        block_book_now_title
      }
    }
  `)

  let dataBookNow
  switch (currentLanguage) {
    case "fr":
      if (data.blocBookListFr) {
        dataBookNow = data.blocBookListFr
      }
      break
    default:
      if (data.blocBookListEn) {
        dataBookNow = data.blocBookListEn
      }
  }
  return (
    <section className={"bookingBar " + extraClass}>
      {screen.isMobile && (
        <div className="blk-reservationMob d-flex align-items-center justify-content-center align-content-center">
          <div className="row">
            <div className="col">
              <span onClick={handleToggle} className="js-toggleBooking">
                {currentLanguage === "fr" ? "Réserver" : "Book now"}
                {currentLanguage === "fr" ? "" : ""}
              </span>
            </div>
            <div className="col">
              <span>
                <Link
                  aria-label="mail"
                  to={currentLanguage === "fr" ? "/contact" : "/en/contact-en"}
                >
                  <i className="icon-mail"></i>
                </Link>
              </span>
              <span>
                <a aria-label="Tel" href="tel:+230 260 5101">
                  <i className="icon-tel"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
      )}
      <form
        action={baseUrl}
        target="_blank"
        method="GET"
        className="blkFormBook hideForm"
      >
        <span className="js-close-booking">
          <i className="icon-close" onClick={handleToggle}></i>
        </span>

        {/*{ <input*/}
        {/*type="hidden"*/}
        {/*name="CheckInCheckOut"*/}
        {/*value={*/}
        {/*  moment(startDate).format("MM/DD/yyyy") +*/}
        {/*  "-" +*/}
        {/*  moment(endDate).format("MM/DD/yyyy")*/}
        {/*}*/}
        {/*/> }*/}

        <Container>
          <Row>
            <Col md={6} className="blkWhyBook">
              <div>
                <h2
                  onClick={screen.isMobile && toggleAccordion}
                  className={screen.isMobile ? "js-toggle-mob" : ""}
                >
                  <span>{dataBookNow.block_book_now_title}</span>
                </h2>
                <div className="blkWhyBookAll">
                  <div className="blkWhyBook-content">
                    {HTMLReactParser(dataBookNow.block_book_now_text.value)}
                  </div>
                  <div className="blkWhyBook-condition">
                    <span>
                      <Link
                        to={
                          currentLanguage == "en"
                            ? "/en/infos/terms-and-conditions"
                            : "/hotel-ile-maurice/conditions-generales"
                        }
                      >
                        {currentLanguage === "fr"
                          ? "*Conditions applicables"
                          : "*Terms and conditions apply"}
                      </Link>
                    </span>
                  </div>
                  <div className="blkWhyBook-contact">
                    <Row>
                      <Col md={12}>
                        <div className="contactNumber">
                          {HTMLReactParser(
                            dataBookNow.block_book_now_telephone.value
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Link
                          className="btn btnLight covid-popin"
                          to={
                            currentLanguage === "fr"
                              ? "/hotel-ile-maurice/protocole-sanitaire-post-covid19"
                              : "/en/infos/health-and-hygiene-protocol-post-covid19"
                          }
                        >
                          <i className="icon-info"></i>
                          <em>
                            {currentLanguage === "fr"
                              ? "COVID-19 "
                              : "COVID-19 "}
                          </em>
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={6} className="blkFormBook">
              <Row>
                <Row className="blkHeaderBook">
                  <Col md={6}>
                    <h2>
                      {currentLanguage === "fr"
                        ? "Votre réservation "
                        : "Your reservation"}
                    </h2>
                  </Col>
                </Row>
                <Row className="blkLinks">
                  <Col md={12}>
                    <div className="blkFormBook-btn">
                      <Link className="simpleLink">
                        {currentLanguage === "fr" ? "Hôtel" : "Hotel"}
                      </Link>
                      <Link
                        className="simpleLink"
                        to={
                          currentLanguage === "fr"
                            ? "/demande-de-devis-hotel-vol"
                            : "/en/online-booking-flight-request"
                        }
                      >
                        {currentLanguage === "fr"
                          ? "Hôtel et vol"
                          : "Hotel & Flight"}
                      </Link>
                    </div>
                  </Col>
                </Row>
                <Row className="blkHotelBook">
                  <Col md={12} className="colHotelSelect">
                    <FormControl>
                      <InputLabel htmlFor="hotel">Hotel</InputLabel>
                      <Select
                        id="hotel"
                        label="hotel"
                        //name={selectedHotel === "verandaResorts" ? "" : "hotel"}
                        //classes="selectHotel"
                        onChange={handleHotelChange}
                        value={selectedHotel}
                      >
                        <MenuItem value="verandaResorts">
                          {currentLanguage === "fr"
                            ? "Choisissez votre hôtel"
                            : "Choose your hotel"}
                        </MenuItem>
                        {hotelOptions.map((hotel, index) => (
                          <MenuItem key={index} value={hotel.idBooking}>
                            {hotel.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                <Row className="calcGuest">
                  <Col md={6}>
                    <FormControl sx={{ m: 1, width: 430 }}>
                      <InputLabel htmlFor="adult">
                        {currentLanguage === "fr" ? "Adultes" : "Adults"}
                      </InputLabel>
                      <Select
                        id="adult"
                        label="adult"
                        name="adult"
                        defaultValue={2}
                        onChange={handleAdults}
                      >
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                        <MenuItem value={4}>4</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={6}>6</MenuItem>
                        <MenuItem value={7}>7</MenuItem>
                        <MenuItem value={8}>8</MenuItem>
                        <MenuItem value={9}>9</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={11}>11</MenuItem>
                        <MenuItem value={12}>12</MenuItem>
                      </Select>
                    </FormControl>
                    <input type="hidden" name="chain" value={14463} />
                  </Col>
                  <Col md={6}>
                    <FormControl
                      sx={{ m: 1, width: 430 }}
                      className={
                        selectedHotel === "74756" ? "hotelPaulEtVirginie" : ""
                      }
                    >
                      <InputLabel htmlFor="children">
                        {currentLanguage === "fr"
                          ? "Enfants (2 - 11.99ans)"
                          : "Children (2 - 11.99yrs)"}
                      </InputLabel>
                      <Select
                        disabled={selectedHotel === "74756" ? 1 : 0}
                        defaultValue={0}
                        id="children"
                        label="children"
                        name="child"
                        onChange={handleChild}
                        // onChange={({ target }) => changeValues(target)}
                      >
                        <MenuItem value="0">0</MenuItem>
                        <MenuItem value="1">1</MenuItem>
                        <MenuItem value="2">2</MenuItem>
                        <MenuItem value="3">3</MenuItem>
                        <MenuItem value="4">4</MenuItem>
                        <MenuItem value="5">5</MenuItem>
                        <MenuItem value="6">6</MenuItem>
                        <MenuItem value="7">7</MenuItem>
                        <MenuItem value="8">8</MenuItem>
                        <MenuItem value="9">9</MenuItem>
                        <MenuItem value="10">10</MenuItem>
                        <MenuItem value="11">11</MenuItem>
                        <MenuItem value="12">12</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                <Row>
                  {/*{config}*/}
                  <input
                    type="hidden"
                    name="arrive"
                    value={
                      currentLanguage === "en"
                        ? moment(startDate).format("M/DD/yyyy")
                        : moment(startDate).format("DD/MM/yyyy")
                    }
                  />
                  <input
                    type="hidden"
                    name="depart"
                    value={
                      currentLanguage === "en"
                        ? moment(endDate).format("M/DD/yyyy")
                        : moment(endDate).format("DD/MM/yyyy")
                    }
                  />
                  <input type="hidden" name="LanguageID" value={lang} />
                  <input type="hidden" name="locale" value={localeVal} />
                  {roomId && (
                    <input type="hidden" name="roomtypeid" value={roomId} />
                  )}
                  {idHotel && (
                    <input type="hidden" name="hotel" value={idHotel} />
                  )}
                  {theme && <input type="hidden" name="theme" value={theme} />}
                  {dest && <input type="hidden" name="dest" value={dest} />}
                  {config && (
                    <input type="hidden" name="config" value={config} />
                  )}
                  {clearcache && (
                    <input type="hidden" name="clearcache" value={clearcache} />
                  )}
                  <input type="hidden" name="agencyid" value="RH31803" />
                </Row>
                <Row className="blkCustomCalendar">
                  <Col md={6}>
                    <DatePicker
                      monthsShown={screen.isMobile ? 1 : 2}
                      selected={endDate}
                      onChange={update => {
                        setDateRange(update)
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      minDate={addDays(new Date(), 0)}
                      dateFormat="d MMM yy"
                      id="daterange"
                      locale={currentLanguage}
                      selectsRange={true}
                      onChangeRaw={handleDateChangeRaw}
                      onFocus={e => e.target.blur()}
                      popperPlacement="top"
                      customInput={
                        <CustomDatePicker
                          dept={
                            currentLanguage === "fr" ? "Arrivée" : "Arrival"
                          }
                          customDay={startDate.toLocaleString(currentLanguage, {
                            day: "numeric",
                          })}
                          customYear={startDate.toLocaleString(
                            currentLanguage,
                            {
                              month: "short",
                              year: "numeric",
                            }
                          )}
                        />
                      }
                    />
                  </Col>
                  <Col md={6}>
                    <DatePicker
                      monthsShown={screen.isMobile ? 1 : 2}
                      selected={endDate}
                      onChange={update => {
                        setDateRange(update)
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      minDate={addDays(new Date(), 1)}
                      dateFormat="d MMM yy"
                      id="daterange"
                      locale={currentLanguage}
                      selectsRange={true}
                      onChangeRaw={handleDateChangeRaw}
                      onFocus={e => e.target.blur()}
                      popperPlacement="top"
                      customInput={
                        <CustomDatePicker
                          dept={
                            currentLanguage === "fr" ? "Départ" : "Departure"
                          }
                          customDay={
                            endDate
                              ? endDate.toLocaleString(currentLanguage, {
                                  day: "numeric",
                                })
                              : ""
                          }
                          customYear={
                            endDate
                              ? endDate.toLocaleString(currentLanguage, {
                                  month: "short",
                                  year: "numeric",
                                })
                              : ""
                          }
                        />
                      }
                    />
                  </Col>
                </Row>
                <Row className="blkCalendarBook">
                  <Col md={12} className="colDatePicker focused">
                    <div className="MuiFormControl-root">
                      <InputLabel htmlFor="daterange">
                        {currentLanguage === "fr"
                          ? "Dates de voyage"
                          : "Travelling Dates"}
                      </InputLabel>
                      <DatePicker
                        monthsShown={screen.isMobile ? 1 : 2}
                        selected={endDate}
                        onChange={update => {
                          setDateRange(update)
                        }}
                        startDate={startDate}
                        endDate={endDate}
                        minDate={addDays(new Date(), 1)}
                        dateFormat="d MMM yy"
                        id="daterange"
                        locale={currentLanguage}
                        selectsRange={true}
                        onChangeRaw={handleDateChangeRaw}
                        onFocus={e => e.target.blur()}
                        popperPlacement="top"
                        // onFocus={handleFocus}
                        // onBlur={handleFocusRemove}
                      />
                    </div>
                    <svg
                      className="MuiSvgIcon-root MuiSelect-icon svg-calendar"
                      focusable="false"
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      data-testid="ArrowDropDownIcon"
                    >
                      <path d="M7 10l5 5 5-5z"></path>
                    </svg>
                  </Col>
                </Row>
                {/* <Row>
                  <Col md={6}>
                    <FormControl>
                      <InputLabel htmlFor="promo-code">
                        {intl.formatMessage({ id: "form_inputs.promo-code" })}
                      </InputLabel>
                      <Input id="promo-code" name="" type="text" />
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <FormControl>
                      <InputLabel htmlFor="agencyid">
                        {intl.formatMessage({ id: "form_inputs.agencyid" })}
                      </InputLabel>
                      <Input id="agencyid" name="" type="text" />
                    </FormControl>
                  </Col>
                </Row> */}
                <Row className="bookingSubmit">
                  <Col md={6}>
                    <a
                      className="btn btnLight"
                      href={
                        currentLanguage === "fr"
                          ? "/demandez-un-devis"
                          : "/en/mauritius-hotels/ask-quote"
                      }
                    >
                      <span>
                        {currentLanguage === "fr"
                          ? "Demander un devis"
                          : "Ask for a quote"}
                      </span>
                    </a>
                  </Col>
                  <Col md={6}>
                    <button
                      type="submit"
                      className="btn btnPrimary btnCheckAvailable"
                    >
                      <span>
                        {currentLanguage === "fr" ? "Réserver" : "Book now"}
                      </span>
                    </button>
                  </Col>
                </Row>
              </Row>
            </Col>
          </Row>
        </Container>
      </form>
    </section>
  )
}

export default BlockBooking
